var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"18","viewBox":"0 0 21 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"21","height":"5","fill":"#E92A2A"}}),_c('rect',{attrs:{"y":"13","width":"21","height":"5","fill":"#E92A2A"}}),_c('rect',{attrs:{"y":"5","width":"21","height":"8","fill":"#F0C733"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }